const LANG_ALIASES = {
    pt: "ptBr",
    "pt-br": "ptBr",
    ptbr: "ptBr",
    en: "en",
    "en-us": "en",
    "en-gb": "en",
    es: "es",
    "es-es": "es",
    "es-mx": "es",
};

export const normalizeLang = (lang) => {
    if (!lang || typeof lang !== "string") {
        return null;
    }

    const normalized = lang.trim().toLowerCase().replace(/_/g, "-");
    return LANG_ALIASES[normalized] || null;
};

export const getRouteLang = (route) => normalizeLang(route?.query?.lang);

export const resolveInitialLang = (route) => {
    return getRouteLang(route) || "ptBr";
};
